import { render, staticRenderFns } from "./news-content.vue?vue&type=template&id=1c552136&"
import script from "./news-content.vue?vue&type=script&lang=js&"
export * from "./news-content.vue?vue&type=script&lang=js&"
import style0 from "./news-content.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports